import { Flex, Icon, ProductColor, Tooltip, Typography } from '@aloft/toolkit-sui';

import { selectImprovementsCostDisplay } from '../redux/features/selectors/selectImprovementsCost.ts';
import { useAppSelector } from '../redux/hooks.ts';
import { selectSiteValueDisplay } from '../redux/features/selectors/selectSiteValue.ts';

export const IndicatedValueInformationIcon = ({
  propertyId,
  compIsManuallyAdjusted,
  color,
}: {
  propertyId: string;
  compIsManuallyAdjusted: boolean;
  color?: ProductColor
}) => {
  const improvementsValue = useAppSelector((state) =>
    selectImprovementsCostDisplay(state, propertyId),
  );
  const siteValue = useAppSelector((state) => selectSiteValueDisplay(state, propertyId));

  return (
    <Tooltip
      label={
        <Flex flexDirection="column">
          {compIsManuallyAdjusted ? (
            <Typography variant="h5" color="textOffset">This Comp was manually adjusted by the appraiser.</Typography>
          ) : (
            <>
              <Typography variant="h5" color="textOffset">
                Improvements + Site
              </Typography>
              <Typography variant="h5" color="textOffset">
                {improvementsValue ?? '$ -'} + {siteValue ?? '$ -'}
              </Typography>
            </>
          )}

        </Flex>
      }
      placement="right"
      hasArrow
    >
      <Flex>
        {compIsManuallyAdjusted ? (
          <Icon icon="information-inverse" color="statusWarning" />
        ) : (
          <Icon icon="information" color={color ?? "textOffset"} />
        )}
      </Flex>
    </Tooltip>
  );
};
